import { render, staticRenderFns } from "./ConcessionAdd.vue?vue&type=template&id=15d0dbfb&scoped=true&"
import script from "./ConcessionAdd.vue?vue&type=script&lang=js&"
export * from "./ConcessionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0dbfb",
  null
  
)

export default component.exports